import React from 'react';

export const ChatIcon = ({ size = 24, color = '#007E47' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path d="M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2Z" fill={color} />
    <path d="M7 9H17M7 13H13" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);



// WEBPACK FOOTER //
// ./src/assets/icons/Chat.icon.jsx